function containsH1(node) {
  return node.tagName === "h1" || (node.children || []).some(containsH1);
}

// About-page CMS heroes store their visible title as a leading Markdown H2.
// Preserve that content and its H2 styling while giving the page a single H1.
function promoteIntroHeading() {
  return tree => {
    if (containsH1(tree)) return;
    const first = (tree.children || []).find(node =>
      node.type !== "comment" && !(node.type === "text" && !node.value.trim()),
    );
    if (first?.type !== "element" || first.tagName !== "h2") return;
    first.tagName = "h1";
    const classes = first.properties?.className || [];
    first.properties = {
      ...first.properties,
      className: [...(Array.isArray(classes) ? classes : [classes]), "h2"],
    };
  };
}

module.exports = { promoteIntroHeading };
